import React, { useEffect, useState } from 'react';
import { arrival } from '../arrival';
import { readInvite } from '../invites';

// "{First name} invited you to study together" on the landing and Sign up, when the
// visitor came through an invite link (P-1). An unknown code shows nothing.
function InviteBanner({ className = '' }) {
  const [invite, setInvite] = useState(null);
  useEffect(() => {
    let live = true;
    const { invite: code } = arrival();
    if (code) readInvite(code).then(i => live && setInvite(i));
    return () => { live = false; };
  }, []);
  if (!invite) return null;
  return (
    <div className={`invite-banner ${className}`} role="status">
      <strong>{invite.inviterFirstName || 'A study partner'} invited you to study together</strong>
      <span>Create your account and you'll be connected right away.</span>
    </div>
  );
}
export default InviteBanner;
